export default __webpack_public_path__ + "static/media/single3.ad3ef81509e5c5a42dcb9149dc35ba8e.svg";